import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorMessage } from 'js/hooks/server/hooks';

import * as server from './server';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';

export const useFetchComponent = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const getErrorMessage = useGetErrorMessage();
    const { from: startDate, until: endDate, product } = useDynamicReducerSelector(pick(
        ['from', 'until', 'product']
    ));

    return useCallback(() => {
        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError({ error: '' }));

        (async () => {
            try {
                const response = await server.getTaxableWinnings({ startDate, endDate, product });
                const { transactions = [], winLoss = {} } = response.data || {};

                isMounted() && dispatch(actions.updateWinnings({ transactions, winLoss }));
            } catch (error) {
                const errorMsg = getErrorMessage(error);

                isMounted() && dispatch(actions.setError({ error: errorMsg, isFetchError: true }));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [dispatch, isMounted, getErrorMessage, startDate, endDate, product]);
};
